import React from 'react';
import WorkflowManager from '../components/WorkflowManagerNew';

export default function WorkflowsPage() {
  // WorkflowsPage component is rendering

  return (
    <div className='p-6'>
      <WorkflowManager />
    </div>
  );
}
